// Func = limiting Scope for this file
var lastScrollTop = 0;

//datepicker booking
var opened = 0;
var start = $('#arriveInput').attr('value');
var end = $('#departureInput').attr('value');
var opencheck = 0;
var firstClick = 0; 
(function(){

	$(document).ready(function () {

		 // Main Nav Dropdown
		 $("#primary-nav li.privary-navigation__item").has( "ul" ).hover(function() {
            $(this).addClass("hover");
            $('ul.submenu', this).fadeIn(200);
        }, function() {
            $(this).removeClass("hover");
            $('ul.submenu', this).fadeOut(200);
        });
		
		//To create after event 
		$.datepicker._updateDatepicker_original = $.datepicker._updateDatepicker;
		$.datepicker._updateDatepicker = function (inst) {
			$.datepicker._updateDatepicker_original(inst);
			var afterShow = this._get(inst, 'afterShow');
			if (afterShow)
				afterShow.apply((inst.input ? inst.input[0] : null));  // trigger custom callback
		}
		$('#arriveInput').on('change', function(){
			start = $(this).val();
			$('.calendar-block').datepicker("setDate", start)
		})
		$('#departureInput').on('change', function(){
			end = $(this).val();
			$('.calendar-block').datepicker("setDate", end)
		})

		$('.calendar-block').datepicker({ 
			changeMonth: true,
			dateFormat: 'mm/dd/yy',
			numberOfMonths: 2,
			changeMonth:false,
			//altField: "#arriveInput",
			//altFormat: "mm-dd-yy",
			beforeShowDay: function (date) {
 
				$.datepicker._defaults.dateFormat = "mm/dd/yy";
				var startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				if (date.getTime() == startDate.getTime()) {
					return [true, "startday"];
				} else {
					if (date.getTime() == endDate.getTime()) {
						return [true, "endday"];
					} else {
						if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
							return [true, "days"];
						} else {
							return [true, ""];
						}
					}
				}
			},
			onSelect: function (date) {
				var arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start);
				var departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end);
				var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

				if (opened == 0) {
					opened = 1;
					start = date;
					end = date;
					opencheck = 0;
				} else {
					opened = 0;
					if (selectedDate <= arrive) {
						end = start;
						start = date;
					} else {
						end = date;
					}
				
					
				}
				//console.log(start);
				//console.log(end);

				$('#arriveInput').attr('value', start);
				$('#departureInput').attr('value', end);

				let check_in_date = start.split('/'),
					check_out_date = end.split('/');

				document.querySelector('input[name="checkin"]').value = check_in_date[2]+'-'+check_in_date[0]+'-'+check_in_date[1]
				document.querySelector('input[name="checkout"]').value = check_out_date[2]+'-'+check_out_date[0]+'-'+check_out_date[1]
			
			},
			onChangeMonthYear: function () {
				opencheck = 1;
			}
		});

		let booking_form_header = document.getElementById('bookingBox');
		if (booking_form_header) {
			booking_form_header.addEventListener( 'submit', (e) => {
				e.preventDefault();
				console.warn('URL of BE biuld on custom.js');

				let allInputs = booking_form_header.querySelectorAll('input, select'),
					url_be = booking_form_header.querySelector('form').getAttribute('action')+'?';
				console.log(url_be);
				allInputs.forEach( each_input => {
					if( each_input.getAttribute('name') ){
						url_be += each_input.getAttribute('name')+'='+each_input.value+'&'
					}
				});
				url_be = url_be.replace('&checkin', '#checkin');
				window.open(url_be, '_blank')
			} );
		}

		$('.header__burger, .burger__close').click(function() {
		    $('.burger').toggleClass('open');
		});
		document.querySelectorAll('.js-open-widget').forEach(btn => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				document.getElementById('bookingBox').classList.toggle('open');
			});
		});
		document.querySelectorAll('.booking-close').forEach(btn => {
			btn.addEventListener('click', _ => {
				document.getElementById('bookingBox').classList.toggle('open');
			});
		});

	});

	window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
	};

}());

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
	const window_height = window.innerHeight;
	let animatedEl = document.getElementsByClassName('animate');
	for (let i = 0; i < animatedEl.length; i++) {
		var viewportOffset = animatedEl[i].getBoundingClientRect();
		let topPos = viewportOffset.top;
		if(topPos <= window_height*0.8){
			animatedEl[i].classList.add('fade-in');
		}
	}

}


